import { UserProfile } from "@/app/@types";
import { supabase } from "../supabase-client";

export const createUserProfile = async (
  userId: string,
  email: string
): Promise<UserProfile | null> => {
  try {
    if (!userId || !email) {
      console.error("User ID and email are required");
      return null;
    }

    const profile: Partial<UserProfile> = {
      id: userId,
      username: email.split("@")[0],
      email,
      score: 0,
      streak: 0,
      crowd_beats: 0,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
    };

    console.log("Creating user profile...");
    const { data, error } = await supabase
      .from("user_profiles")
      .insert(profile)
      .select()
      .single();

    if (error) {
      console.error("Error creating user profile:", error);
      return null;
    }

    if (!data) {
      console.error("No data returned after creating profile");
      return null;
    }

    console.log("Profile created successfully:", data);
    return data;
  } catch (error) {
    console.error("Unexpected error creating user profile:", error);
    return null;
  }
};
